const NextI18Next = require("next-i18next");

const COMMON_NAMESPACES = ['navbar', 'footer', 'common', 'cookie']

module.exports = { ...NextI18Next, COMMON_NAMESPACES };
